var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 7.40625C5.98438 7.8125 6.45312 8.01562 6.98438 8.01562C7.51562 8.01562 7.98438 7.8125 8.39062 7.40625C8.79688 7 9 6.53125 9 6C9 5.46875 8.79688 5 8.39062 4.59375C7.98438 4.1875 7.51562 3.98438 6.98438 3.98438C6.45312 3.98438 5.98438 4.1875 5.57812 4.59375C5.20312 5 5.01562 5.46875 5.01562 6C5.01562 6.53125 5.20312 7 5.57812 7.40625ZM12.6562 3.98438H23.0156V8.01562H21V12H17.0156V8.01562H12.6562C12.25 9.10938 11.4844 10.0469 10.3594 10.8281C9.26562 11.6094 8.14062 12 6.98438 12C5.32812 12 3.90625 11.4219 2.71875 10.2656C1.5625 9.07812 0.984375 7.65625 0.984375 6C0.984375 4.34375 1.5625 2.9375 2.71875 1.78125C3.90625 0.59375 5.32812 0 6.98438 0C8.14062 0 9.26562 0.390625 10.3594 1.17188C11.4844 1.95312 12.25 2.89062 12.6562 3.98438Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyPassword);
export default __webpack_public_path__ + "static/media/key_password.55e1b459fedf97a71160ab333a4f7ceb.svg";
export { ForwardRef as ReactComponent };